import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as formActions from "../../../store/actions/forms";
import styles from "./WorkersCompForm.module.css";
import Input from "../../shared/ui/input/Input";
import WCMainForm from "./WCMainForm/WCMainForm";
import { baseTitle } from "../../../constants/messages";

function WorkersCompForm() {
  const dispatch = useDispatch();
  let agent = useSelector((state) => state.user.agentInfo);
  let workCompPolicies = useSelector((state) => state.forms.policies);
  let activePolicy = useSelector((state) => state.policies.activePolicy);
  const [policyNumber, setPolicyNumber] = useState();
  let policySelectOptions;

  // If agent selected policy display only one policy option, otherwise all the policies for an insured
  if (activePolicy) {
    workCompPolicies = [
      {
        policyNumber: activePolicy.PolicyNumber,
        policyEffectiveDate: activePolicy.PolicyEffectiveDate,
        policyType: activePolicy.PolicyType,
      },
    ];

    policySelectOptions = (
      <option
        key={workCompPolicies[0].policyNumber}
        value={`${workCompPolicies[0].policyNumber}/${workCompPolicies[0].policyEffectiveDate}`}
        selected="selected"
      >
        {`${workCompPolicies[0].policyNumber} - ${workCompPolicies[0].policyType}`}
      </option>
    );
  } else {
    policySelectOptions = workCompPolicies.map((policy) => {
      return (
        <option
          key={policy.policyNumber}
          value={`${policy.policyNumber}/${policy.policyEffectiveDate}`}
        >
          {`${policy.policyNumber} - ${policy.policyType}`}
        </option>
      );
    });

    policySelectOptions = [
      <option key={"select"} value="select">
        Select a Policy
      </option>,
      ...policySelectOptions,
    ];
  }

  useEffect(() => {
    if (!activePolicy) {
      dispatch(formActions.getPolicies("WC"));
    }
  }, [dispatch, activePolicy]);

  useEffect(() => {
    document.title = baseTitle + " - Report Workers' Comp Claim";
  }, []);

  return (
    <div className={styles.container}>
      <p>Workers' Compensation Claims</p>
      {agent ? (
        activePolicy && <WCMainForm policyNumber={activePolicy.PolicyNumber} />
      ) : (
        <Fragment>
          <div className="policyBar" style={{ width: "80%" }}>
            <Input label="Policy" width="33%" forId="Policy">
              <select
                name="policy"
                id="Policy"
                onChange={(e) => setPolicyNumber(e.target.value)}
                value={policyNumber}
              >
                {policySelectOptions}
              </select>
            </Input>
            <h3 className={"titleText"}>Let's collect some details: </h3>
          </div>
          {policyNumber && (
            <WCMainForm
              policyNumber={policyNumber.substring(
                0,
                policyNumber.indexOf("/")
              )}
            />
          )}
        </Fragment>
      )}
    </div>
  );
}

export default WorkersCompForm;
